(function () {
  var sharePopupSelector = '[data-share-popup]';
  var defaultPopupWidth = 640;
  var defaultPopupHeight = 520;
  function shouldUseNativeNavigation(event) {
    return event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
  }
  function getPopupDimension(shareLink, attributeName, fallbackValue) {
    var parsedValue = parseInt(shareLink.getAttribute(attributeName), 10);
    if (isNaN(parsedValue) || parsedValue <= 0) {
      return fallbackValue;
    }
    return parsedValue;
  }
  function getPopupFeatures(shareLink) {
    var popupWidth = getPopupDimension(shareLink, 'data-share-popup-width', defaultPopupWidth);
    var popupHeight = getPopupDimension(shareLink, 'data-share-popup-height', defaultPopupHeight);
    var popupLeft = Math.max(0, Math.round((window.screen.width - popupWidth) / 2));
    var popupTop = Math.max(0, Math.round((window.screen.height - popupHeight) / 2));
    return ['scrollbars=yes', 'resizable=yes', 'toolbar=no', 'location=no', 'width=' + popupWidth, 'height=' + popupHeight, 'left=' + popupLeft, 'top=' + popupTop].join(',');
  }
  function openSharePopup(event) {
    if (shouldUseNativeNavigation(event)) {
      return;
    }
    var shareLink = event.currentTarget;
    var shareUrl = shareLink.getAttribute('href');
    if (!shareUrl) {
      return;
    }
    var shareNetwork = shareLink.getAttribute('data-network') || 'share';
    var popupWindow = window.open(shareUrl, 'share-' + shareNetwork, getPopupFeatures(shareLink));
    if (!popupWindow) {
      return;
    }
    event.preventDefault();
    popupWindow.opener = null;
    popupWindow.focus();
  }
  function initSharePopups() {
    var shareLinks = document.querySelectorAll(sharePopupSelector);
    shareLinks.forEach(function (shareLink) {
      shareLink.addEventListener('click', openSharePopup);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSharePopups);
  } else {
    initSharePopups();
  }
})();